import {
  fcheck_null_undefine_replace_empty,
  fAlertToast,
} from "../../Utility/Utilitys";

import { vRdxUserInfo } from "../../Redux/roStore";
import {
  common_groupstructure_GETROW,
  common_brandgroup_GETROW,
  common_brandbasedgroup_GETROW,
  common_LocationSearch_GETROW,
  common_WMSMISAttributes_GETROW,
  common_VendorListReport_GETROW,
  common_ItemsSearchReport_GETROW,
  common_ItemsAnalsys_GETROW,
} from "../../Server/ApiV2";
import { fExecuteAPI } from "../../Server/Apis.jsx";

export const sWebWMSSalesReportData = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
];
export const sWebWMSSalesReportArr = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
  { Uid: "From", Value: "From" },
  { Uid: "To", Value: "To" },
  { Uid: "Between", Value: "Between" },
];
export const sWebBetweenReportArr = [{ Uid: "Between", Value: "Btwn" }];
export const sWebTransTypeReportArr = [
  { Uid: "BOTH", Value: "All" },
  { Uid: "SALES", Value: "Sales" },
  { Uid: "STKTRANS", Value: "Transfer" },
  { Uid: "RETURN", Value: "Return" },
  { Uid: "SAL_RETURN", Value: "Sale Return" },
  { Uid: "TSR_RETURN", Value: "Transfer Return" },
];

export const sWMSSalesReportCheckboxInit = {
  sProperty1Data: false,
  sProperty2Data: false,
  sProperty3Data: false,
  sProperty4Data: false,
  sAnalysis1Data: false,
  sAnalysis2Data: false,
  sAnalysis3Data: false,
  sAnalysis4Data: false,
  sAnalysis5Data: false,
  sAnalysis6Data: false,
  sAnalysis7Data: false,
  sTransTypeData: false,
};

export const HeadObjectInit = {
  sDate: sWebBetweenReportArr[0].Uid,
  sLocation: "Is",
  sMainGroup: "All",
  sSubGroup: "All",
  sGroup: "All",
  sVendor: "All",
  sCustomer: "All",
  sBrand: "All",
  sItem: "All",
  sCountry: "All",
  sSeason: "All",
  sSalesMan: "All",
  sDocType: "All",
  sFromDate: new Date(),
  sToDate: new Date(),
  sLocationArr: [],
  sLocationPrnt: "",
  sLocationCode: "",
  sLocationName: "",
  sMainGroupArr: [],
  sMainGroupPrnt: "",
  sMainGroupCode: "",
  sMainGroupName: "",
  sSubGroupArr: [],
  sSubGroupPrnt: "",
  sSubGroupCode: "",
  sSubGroupName: "",
  sGroupArr: [],
  sGroupPrnt: "",
  sGroupCode: "",
  sGroupName: "",
  sVendorArr: [],
  sVendorPrnt: "",
  sVendorCode: "",
  sVendorName: "",
  sVendorSearchValue: "",
  sCustomerArr: [],
  sCustomerPrnt: "",
  sCustomerCode: "",
  sCustomerName: "",
  sBrandArr: [],
  sBrandPrnt: "",
  sBrandCode: "",
  sBrandName: "",
  sBrandSearchValue: "",
  sBrandGroupArr: [],
  sBrandGroupPrnt: "",
  sBrandGroupCode: "",
  sBrandGroupName: "",
  sItemCode: "",
  sItemName: "",
  sCountryArr: [],
  sCountryPrnt: "",
  sCountryCode: "",
  sCountryName: "",
  sSeasonArr: [],
  sSeasonPrnt: "",
  sSeasonCode: "",
  sSeasonName: "",
  sSalesManArr: [],
  sSalesManPrnt: "",
  sSalesManCode: "",
  sSalesManName: "",
  sDocTypeArr: [],
  sDocTypePrnt: "",
  sDocTypeCode: "",
  sDocTypeName: "",

  //analysis

  sProperty1: "All",
  sProperty1Arr: [],
  sProperty1Prnt: "",
  sProperty1Code: "",
  sProperty1Name: "",
  sProperty2: "All",
  sProperty2Arr: [],
  sProperty2Prnt: "",
  sProperty2Code: "",
  sProperty2Name: "",
  sProperty3: "All",
  sProperty3Arr: [],
  sProperty3Prnt: "",
  sProperty3Code: "",
  sProperty3Name: "",
  sProperty4: "All",
  sProperty4Arr: [],
  sProperty4Prnt: "",
  sProperty4Code: "",
  sProperty4Name: "",
  sAnalysis1: "All",
  sAnalysis1Arr: [],
  sAnalysis1Prnt: "",
  sAnalysis1Code: "",
  sAnalysis1Name: "",
  sAnalysis2: "All",
  sAnalysis2Arr: [],
  sAnalysis2Prnt: "",
  sAnalysis2Code: "",
  sAnalysis2Name: "",
  sAnalysis3: "All",
  sAnalysis3Arr: [],
  sAnalysis3Prnt: "",
  sAnalysis3Code: "",
  sAnalysis3Name: "",
  sAnalysis4: "All",
  sAnalysis4Arr: [],
  sAnalysis4Prnt: "",
  sAnalysis4Code: "",
  sAnalysis4Name: "",
  sAnalysis5: "All",
  sAnalysis5Arr: [],
  sAnalysis5Prnt: "",
  sAnalysis5Code: "",
  sAnalysis5Name: "",
  sAnalysis6: "All",
  sAnalysis6Arr: [],
  sAnalysis6Prnt: "",
  sAnalysis6Code: "",
  sAnalysis6Name: "",
  sAnalysis7: "All",
  sAnalysis7Arr: [],
  sAnalysis7Prnt: "",
  sAnalysis7Code: "",
  sAnalysis7Name: "",
  sTransType: sWebTransTypeReportArr[0].Uid,
  sTransTypeName: sWebTransTypeReportArr[0].Value,
};
export const DropDownDummydata = [
  {
    Cd: "01",
    Name1: "FMCG FOOD",
  },
  {
    Cd: "02",
    Name1: "FMCG NON FOOD",
  },
  {
    Cd: "03",
    Name1: "HEALTH AND BEAUTY",
  },
  {
    Cd: "04",
    Name1: "CHILLED AND DIARY",
  },
  {
    Cd: "05",
    Name1: "FROZEN FOODS",
  },
  {
    Cd: "07",
    Name1: "BAKERY",
  },
  {
    Cd: "08",
    Name1: "ROASTERY",
  },
  {
    Cd: "11",
    Name1: "BEVERAGES",
  },
  {
    Cd: "13",
    Name1: "ELECTRONICS",
  },
  {
    Cd: "14",
    Name1: "HOUSEHOLD",
  },
  {
    Cd: "15",
    Name1: "STAPLES",
  },
  {
    Cd: "16",
    Name1: "STATIONERY DEP",
  },
  {
    Cd: "17",
    Name1: "TOYS  & SPORTS",
  },
  {
    Cd: "18",
    Name1: "GARMENTS",
  },
  {
    Cd: "19",
    Name1: "TEXTILES",
  },
  {
    Cd: "20",
    Name1: "HOME FURNISHING",
  },
  {
    Cd: "21",
    Name1: "FOOT WEAR",
  },
  {
    Cd: "22",
    Name1: "LUGGAGE",
  },
  {
    Cd: "23",
    Name1: "JEWELLERIES & ACCESSORIES",
  },
  {
    Cd: "24",
    Name1: "SHOP CONSUMPTION",
  },
  {
    Cd: "25",
    Name1: "TELEPHONE CARDS",
  },
  {
    Cd: "26",
    Name1: "TOBACCO&ACC",
  },
  {
    Cd: "99",
    Name1: "FRESH ITEMS",
  },
];

export const SummaryReporteData = [
  { Uid: "SMRY_DT", Value: "Datewise Summary" },
  { Uid: "SMRY_LOC", Value: "Location/Customerwise Summary" },
  { Uid: "SMRY_SALES", Value: "Salesmanwise Summary" },
  { Uid: "SMRY_SUPPLIER", Value: "Supplierwise Summary" },
  { Uid: "SMRY_BRAND", Value: "Brandwise Summary" },
  { Uid: "SMRY_DEPT", Value: "Departmentwise Summary" },
  { Uid: "SMRY_SUB_DEPT", Value: "Sub-Dept.wise Summary" },
  { Uid: "SMRY_CAT", Value: "Categorywise Summary" },
  { Uid: "SMRY_GP_INV", Value: "GP . Invoice" },
  { Uid: "SMRY_DEPT_COMP", Value: "Dept.wise Summary Daily Comparision" },
  {
    Uid: "SMRY_SUB_DEPT_COMP",
    Value: "Sub.Dept.wise Summary Daily Comparision",
  },
  { Uid: "SMRY_MONTH", Value: "Monthwise Summary" },
];

export const DetailReporteData = [
  { Uid: "DTIL_ITEM", Value: "Itemwise Detail" },
  { Uid: "DTIL_CUST_CONS", Value: "Customerwise Detail - Consolidate" },
  { Uid: "DTIL_SALES", Value: "Salesmanwise Detail" },
  { Uid: "DTIL_SUPPLIER", Value: "Supplierwise Detail" },
  { Uid: "DTIL_BRAND", Value: "Brandwise Detail" },
  { Uid: "DTIL_DEPT", Value: "Departmentwise Detail" },
  { Uid: "DTIL_SUB_DEPT", Value: "Sub-Dept.wise Detail" },
  { Uid: "DTIL_CAT", Value: "Categorywise Detail" },
  { Uid: "DTIL_SAL_ABOV_COST", Value: "Sales Above Cost" },
  { Uid: "DTIL_SAL_BELOW_COST", Value: "Sales Below Cost" },
  { Uid: "DTIL_SAL_ABOV_BT_COST", Value: "Sales Above Cost Between" },
  { Uid: "DTIL_SAL_DUMP_SUMRY", Value: "Sales Dumps - Summary" },
  { Uid: "DTIL_SAL_DUMP_ITEM", Value: "Sales Dumps - Itemwise" },
  { Uid: "DTIL_DT", Value: "Datewise Detail" },
];
export const AnalysisReporteData = [
  { Uid: "ANAL_DT", Value: "Top Sales by Date " },
  { Uid: "ANAL_DEPT", Value: "Top Sales by Dept" },
  { Uid: "ANAL_SUB_DEPT", Value: "Top Sales by Sub-Dept" },
  { Uid: "ANAL_BRAND", Value: "Top Sales by Categorywise" },
  { Uid: "ANAL_SUPPLIER", Value: "Top Sales by Supplier" },
  { Uid: "ANAL_ITEM", Value: "Top Sales by Item " },
  { Uid: "ANAL_CUST", Value: "Top Sales by Customer " },
  { Uid: "ANAL_SALE", Value: "Top Sales by Salesman " },
  {
    Uid: "ANAL_PUR_VS_SALES_SUPPL",
    Value: "Purchase Vs Sales Supplier",
  },
  {
    Uid: "ANAL_PUR_VS_SALES_DEPT",
    Value: "Purchase Vs Sales Deparment",
  },
  {
    Uid: "ANAL_PUR_VS_SALES_SUB_DEPT",
    Value: "Purchase Vs Sales Sub-Deparment",
  },
  {
    Uid: "ANAL_PUR_VS_SALES_CAT",
    Value: "Purchase Vs Sales Categorywise",
  },
  {
    Uid: "ANAL_PUR_VS_SALES_BRAND",
    Value: "Purchase Vs Sales Brand",
  },

  {
    Uid: "ANAL_PUR_VS_SALES_SUPPL_SMRY",
    Value: "Purchase Vs Sales Supplier-Summary",
  },
  {
    Uid: "ANAL_PUR_VS_SALES_MONTH",
    Value: "Purchase Vs Sales Monthly",
  },
  {
    Uid: "ANAL_PUR_VS_SALES_ITEMS",
    Value: "Purchase Vs Sales Items",
  },
  { Uid: "ANAL_DEPT_AVG_SALE", Value: "Departmentwise Daily Average Sales " },
  {
    Uid: "ANAL_DEPT_MONTH_SALE",
    Value: "Departmentwise Monthly Average Sales",
  },
];
export const ComparisionReporteData = [
  { Uid: "COMP_SUPPLIER", Value: "Supplierwise Summary" },
  { Uid: "COMP_BRAND", Value: "Brandwise Summary" },
  { Uid: "COMP_DEPT", Value: "Departmentwise Summary" },
  { Uid: "COMP_SUB_DEPT", Value: "Sub-Dept.wise Summary" },
  { Uid: "COMP_CAT", Value: "Categorywise Summary" },
  { Uid: "COMP_GP_ITEM", Value: "Itemwise Detail" },
];

export const fWmsStockRepotArr = async (xGroupStructureObj, setGroupData) => {
  let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
  const CurrentMaingroupArr = await common_groupstructure_GETROW(FinalObj);
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};
export const fWmsStockRepotBrandArr = async (
  xGroupStructureObj,
  setGroupData
) => {
  let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
  const CurrentMaingroupArr = await common_brandbasedgroup_GETROW(FinalObj);
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};
export const GetWmsStockRepotBrand = async (setGroupData) => {
  const CurrentMaingroupArr = await common_brandgroup_GETROW("");
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};
export const GetWmsStockRepotVendor = async (setGroupData) => {
  const CurrentMaingroupArr = await common_VendorListReport_GETROW("");
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};

export const fWmsStockRepotHeadObj = async (
  xGroupStructureObj,
  setHeadObject,
  xkey
) => {
  let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
  const CurrentMaingroupArr = await common_groupstructure_GETROW(FinalObj);
  if (CurrentMaingroupArr?.status === 200) {
    setHeadObject((obj) => ({
      ...obj,
      xkey: CurrentMaingroupArr?.data?.ResultSet,
    }));
  }
};

export const GetLocation = async (setLocation) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  //v_AnyData,v_Cd,v_Name,v_Distri,v_UserCd
  var vLocobj = {
    v_AnyData: "",
    v_Cd: "",
    v_Name: "",
    v_Distri: "Y",
    v_UserCd: vRdxUserInfoObj.UserID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLocobj);
  const vLocation = await common_LocationSearch_GETROW(FinalObj);
  if (vLocation?.status === 200) {
    setLocation(vLocation?.data?.ResultSet);
  }
};
export const GetWMSMISAttributes = async (
  setCountryData,
  setSeasonData,
  setSalesManData,
  setVendorData,
  setCustomerData,
  setDocTypeData
) => {
  const vResult = await common_WMSMISAttributes_GETROW("");

  if (vResult?.status === 200) {
    setCountryData(vResult?.data?.ResultSet?.Country);
    setSeasonData(vResult?.data?.ResultSet?.Season);
    setSalesManData(vResult?.data?.ResultSet?.SalesMan);
    setVendorData(vResult?.data?.ResultSet?.Vendor);
    setCustomerData(vResult?.data?.ResultSet?.Customer);
    setDocTypeData(vResult?.data?.ResultSet?.DocTypes);
  }
};

export const GetItemsAnalysis = async (
  setProperty1Data,
  setProperty2Data,
  setProperty3Data,
  setProperty4Data,
  setAnalysis1Data,
  setAnalysis2Data,
  setAnalysis3Data,
  setAnalysis4Data,
  setAnalysis5Data,
  setAnalysis6Data,
  setAnalysis7Data
) => {
  const vLocation = await common_ItemsAnalsys_GETROW("");
  if (vLocation?.status === 200) {
    setProperty1Data(vLocation?.data?.ResultSet?.Property1);
    setProperty2Data(vLocation?.data?.ResultSet?.Property2);
    setProperty3Data(vLocation?.data?.ResultSet?.Property3);
    setProperty4Data(vLocation?.data?.ResultSet?.Property4);
    setAnalysis1Data(vLocation?.data?.ResultSet?.Analysis1);
    setAnalysis2Data(vLocation?.data?.ResultSet?.Analysis2);
    setAnalysis3Data(vLocation?.data?.ResultSet?.Analysis3);
    setAnalysis4Data(vLocation?.data?.ResultSet?.Analysis4);
    setAnalysis5Data(vLocation?.data?.ResultSet?.Analysis5);
    setAnalysis6Data(vLocation?.data?.ResultSet?.Analysis6);
    setAnalysis7Data(vLocation?.data?.ResultSet?.Analysis7);
  }
};

export const GetItemFullSearchArr = async (xItemName) => {
  // let vItemFullSearchDataObj = {
  //   v_AnyData: xItemName,
  //   v_TransType: "F",
  //   v_Report: "Y",
  // };
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: "", //by sir
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI(
    // "ITEM_SEARCHFULL_GETROW",
    "SEARCHEXACTITEM_GETROW",
    FinalObj
  );
  //status code "" so Success is checked
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull.Type.response.data.message
        ? vItemSearchFull.Type.response.data.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};
export const GetSearchItem = async (xData, xType, setSearchGridData) => {
  let vSeatchItem = {
    Data: xData,
    Type: xType,
    Loc: "", //by sir
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchItem);
  const vItemSearch = await common_ItemsSearchReport_GETROW(FinalObj);
  if (vItemSearch?.status === 200) {
    let vItemSearchArr = vItemSearch?.data?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};
export const fValidationHead_Client = (HeadObject) => {
  let iRes = true;

  if (
    HeadObject.sFromDate === "" ||
    HeadObject.sFromDate === null ||
    HeadObject.sFromDate === undefined ||
    HeadObject.sFromDate === "Invalid Date" ||
    HeadObject.sToDate === "" ||
    HeadObject.sToDate === null ||
    HeadObject.sToDate === undefined ||
    HeadObject.sToDate === "Invalid Date"
  ) {
    fAlertToast("FAILED", "Date should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sLocation.toUpperCase() === "IS" &&
    HeadObject.sLocationPrnt === ""
  ) {
    fAlertToast("FAILED", "Location should not be empty");

    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sMainGroup.toUpperCase() === "IS" &&
    HeadObject.sMainGroupPrnt === ""
  ) {
    fAlertToast("FAILED", "MainGroup should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sSubGroup.toUpperCase() === "IS" &&
    HeadObject.sSubGroupPrnt === ""
  ) {
    fAlertToast("FAILED", "sSubGroup should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sGroup.toUpperCase() === "IS" &&
    HeadObject.sGroupPrnt === ""
  ) {
    fAlertToast("FAILED", "sGroup should not be empty");
    iRes = false;
    return iRes;
  }

  if (HeadObject.sItem.toUpperCase() === "IS" && HeadObject.sItemCode === "") {
    fAlertToast("FAILED", "sItemCode should not be empty");
    iRes = false;
    return iRes;
  }
  if (HeadObject.sItem.toUpperCase() === "IS" && HeadObject.sItemName === "") {
    fAlertToast("FAILED", "sItemName should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sBrand.toUpperCase() === "IS" &&
    HeadObject?.sBrandArr.map((x) => x.UID).join(",") === ""
  ) {
    fAlertToast("FAILED", "sBrand should not be empty");
    iRes = false;
    return iRes;
  }
  // if (
  //   HeadObject.sBrand.toUpperCase() === "IS" &&
  //   HeadObject.sBrandGroupPrnt === ""
  // ) {
  //   fAlertToast("FAILED", "sBrandGroup should not be empty");
  //   iRes = false;
  //   return iRes;
  // }

  if (
    HeadObject.sVendor.toUpperCase() === "IS" &&
   HeadObject?.sVendorArr.map((x) => x.AcCd).join(",") === ""
  ) {
    fAlertToast("FAILED", "sVendor should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sCountry.toUpperCase() === "IS" &&
    HeadObject.sCountryPrnt === ""
  ) {
    fAlertToast("FAILED", "sCountry should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sSeason.toUpperCase() === "IS" &&
    HeadObject.sSeasonPrnt === ""
  ) {
    fAlertToast("FAILED", "sSeason should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sSalesMan.toUpperCase() === "IS" &&
    HeadObject.sSalesManPrnt === ""
  ) {
    fAlertToast("FAILED", "sSalesMan should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sCustomer.toUpperCase() === "IS" &&
    HeadObject.sCustomerPrnt === ""
  ) {
    fAlertToast("FAILED", "sCustomer should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sDocType.toUpperCase() === "IS" &&
    HeadObject.sDocTypePrnt === ""
  ) {
    fAlertToast("FAILED", "sDocType should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sCustomer.toUpperCase() === "IS" &&
    HeadObject.sCustomerPrnt === ""
  ) {
    fAlertToast("FAILED", "sCustomer should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sProperty1.toUpperCase() === "IS" &&
    HeadObject.sProperty1Prnt === ""
  ) {
    fAlertToast("FAILED", "sProperty1 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sProperty2.toUpperCase() === "IS" &&
    HeadObject.sProperty2Prnt === ""
  ) {
    fAlertToast("FAILED", "sProperty2 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sProperty3.toUpperCase() === "IS" &&
    HeadObject.sProperty3Prnt === ""
  ) {
    fAlertToast("FAILED", "sProperty3 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sProperty4.toUpperCase() === "IS" &&
    HeadObject.sProperty4Prnt === ""
  ) {
    fAlertToast("FAILED", "sProperty4 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sAnalysis1.toUpperCase() === "IS" &&
    HeadObject.sAnalysis1Prnt === ""
  ) {
    fAlertToast("FAILED", "sAnalysis1 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sAnalysis2.toUpperCase() === "IS" &&
    HeadObject.sAnalysis2Prnt === ""
  ) {
    fAlertToast("FAILED", "sAnalysis2 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sAnalysis3.toUpperCase() === "IS" &&
    HeadObject.sAnalysis3Prnt === ""
  ) {
    fAlertToast("FAILED", "sAnalysis3 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sAnalysis4.toUpperCase() === "IS" &&
    HeadObject.sAnalysis4Prnt === ""
  ) {
    fAlertToast("FAILED", "sAnalysis4 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sAnalysis5.toUpperCase() === "IS" &&
    HeadObject.sAnalysis5Prnt === ""
  ) {
    fAlertToast("FAILED", "sAnalysis5 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sAnalysis6.toUpperCase() === "IS" &&
    HeadObject.sAnalysis6Prnt === ""
  ) {
    fAlertToast("FAILED", "sAnalysis6 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sAnalysis7.toUpperCase() === "IS" &&
    HeadObject.sAnalysis7Prnt === ""
  ) {
    fAlertToast("FAILED", "sAnalysis7 should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sTransType === "" ||
    HeadObject.sTransType === null ||
    HeadObject.sTransType === undefined
  ) {
    fAlertToast("FAILED", "TransType should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sTransTypeName === "" ||
    HeadObject.sTransTypeName === null ||
    HeadObject.sTransTypeName === undefined
  ) {
    fAlertToast("FAILED", "TransTypeName should not be empty");
    iRes = false;
    return iRes;
  }

  return iRes;
};
export const fValidationDetail_Client = (sBufferObj, HeadObject) => {
  let iRes = true;
  if (
    sBufferObj.sDetailReportRadioBtnName === "" ||
    sBufferObj.sDetailReportRadioBtnName === null ||
    sBufferObj.sDetailReportRadioBtnName === undefined
  ) {
    fAlertToast("FAILED", "DetailReport should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    sBufferObj.sDetailReportRadioBtnName === "SUMMARY" &&
    sBufferObj.DetailSelectedReport === "SMRY_LOC" &&
    (sBufferObj.sSummaryLocCustCheckBox === "" ||
      sBufferObj.sSummaryLocCustCheckBox === null ||
      sBufferObj.sSummaryLocCustCheckBox === undefined)
  ) {
    fAlertToast("FAILED", "Pivot should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    sBufferObj.sDetailReportRadioBtnName === "DETAIL" &&
    sBufferObj.DetailSelectedReport === "DTIL_SAL_ABOV_COST" &&
    (sBufferObj.sDetailSalesAbvCost === "" ||
      sBufferObj.sDetailSalesAbvCost === null ||
      sBufferObj.sDetailSalesAbvCost === undefined)
  ) {
    fAlertToast("FAILED", "Sales above cost should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    sBufferObj.sDetailReportRadioBtnName === "DETAIL" &&
    sBufferObj.DetailSelectedReport === "DTIL_SAL_BELOW_COST" &&
    (sBufferObj.sDetailSalesBelowCost === "" ||
      sBufferObj.sDetailSalesBelowCost === null ||
      sBufferObj.sDetailSalesBelowCost === undefined)
  ) {
    fAlertToast("FAILED", "Sales below cost should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    sBufferObj.sDetailReportRadioBtnName === "DETAIL" &&
    sBufferObj.DetailSelectedReport === "DTIL_SAL_ABOV_BT_COST" &&
    (sBufferObj.sDetailSalesAboveBtCostFrom === "" ||
      sBufferObj.sDetailSalesAboveBtCostFrom === null ||
      sBufferObj.sDetailSalesAboveBtCostFrom === undefined ||
      sBufferObj.sDetailSalesAboveBtCostTo === "" ||
      sBufferObj.sDetailSalesAboveBtCostTo === null ||
      sBufferObj.sDetailSalesAboveBtCostTo === undefined)
  ) {
    fAlertToast("FAILED", "Sales above cost should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    sBufferObj.sDetailReportRadioBtnName === "DETAIL" &&
    sBufferObj.DetailSelectedReport === "DTIL_SAL_ABOV_BT_COST" &&
    sBufferObj.sDetailSalesAboveBtCostFrom >
      sBufferObj.sDetailSalesAboveBtCostTo
  ) {
    fAlertToast("FAILED", "Profit Type should not be greater than percentage");
    iRes = false;
    return iRes;
  }
  if (
    sBufferObj.sDetailReportRadioBtnName === "COMPARISON" &&
    (sBufferObj.sCompr_FromDt === "" ||
      sBufferObj.sCompr_FromDt === null ||
      sBufferObj.sCompr_FromDt === undefined ||
      sBufferObj.sCompr_FromDt === "Invalid Date" ||
      sBufferObj.sCompr_ToDt === "" ||
      sBufferObj.sCompr_ToDt === null ||
      sBufferObj.sCompr_ToDt === undefined ||
      sBufferObj.sCompr_ToDt === "Invalid Date")
  ) {
    fAlertToast("FAILED", "Comparison date should not be empty");
    iRes = false;
    return iRes;
  }

  return iRes;
};
